export default __webpack_public_path__ + "static/media/6.de9b0cae.png";